import { httpClient } from '@/services/http/httpClient'

export type ProjectHistory = {
  id: string
  projectId: string
  title: string
  description: string
  timestamp: string
  createdAt: string
  updatedAt: string
}

export type GetProjectHistoryResponse = {
  history: ProjectHistory[]
  paginate: {
    limit: number
    total: number
    page: number
    pages: number
  }
}

export type GetProjectHistoryParams = {
  projectId: string
  limit: number
  page: number
}

export const getProjectHistory = async ({
  projectId,
  limit,
  page,
}: GetProjectHistoryParams): Promise<GetProjectHistoryResponse> => {
  const { data } = await httpClient.get(
    `/projects/portfolio-projects/${projectId}/history`,
    {
      params: {
        limit,
        page,
      },
    },
  )

  return data
}
